import React, { useContext } from "react";
import FancyButton from "../components/FancyButton";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";
import NotificationContext from "../context/NotificationContext";
import { BEHANCE_URL, DRIBBBLE_URL, EMAIL, LINKEDIN_URL } from "./contact";

export default function Footer() {
	const { ref, inView } = useInView({
		threshold: 0.1,
		triggerOnce: true,
	});
	const showSnackbar = useContext(NotificationContext);

	const copyEmail = async () => {
		try {
			await navigator.clipboard.writeText(EMAIL);
			showSnackbar("Email copied!");
		} catch {
			window.location.href = `mailto:${EMAIL}`;
		}
	};

	return (
		<footer>
			<motion.div
				className="footer"
				ref={ref}
				initial={{ opacity: 0, y: 200 }}
				animate={{
					opacity: inView ? 1 : 0,
					y: inView ? 0 : 200,
				}}
				transition={{ ease: "easeOut", duration: 0.6 }}
			>
				<div className="container">
					<h2>Get in touch</h2>
					<div className="content">
						<div className="fill" />
						<div className="content-inner">
							<p className="xs">
								Have an interesting product, opportunity, or idea?
								Let’s talk.
							</p>
							<FancyButton
								label="Email me"
								linkTo={`mailto:${EMAIL}`}
								black
								external
								ariaLabel={`Email me at ${EMAIL}`}
							/>
						</div>
					</div>
				</div>

				<div className="footer-bottom">
					<p className="ending-footer">
						Built with <i>you</i> in mind.
					</p>
					<ul className="footer-links">
						<li>
							<a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer">
								LinkedIn
								<span className="visually-hidden"> (opens in a new tab)</span>
							</a>
						</li>
						<li>
							<a href={BEHANCE_URL} target="_blank" rel="noopener noreferrer">
								Behance
								<span className="visually-hidden"> (opens in a new tab)</span>
							</a>
						</li>
						<li>
							<a href={DRIBBBLE_URL} target="_blank" rel="noopener noreferrer">
								Dribbble
								<span className="visually-hidden"> (opens in a new tab)</span>
							</a>
						</li>
						<li>
							<button
								type="button"
								className="email-footer"
								onClick={copyEmail}
								aria-label={`Copy email address ${EMAIL}`}
							>
								{EMAIL}
							</button>
						</li>
					</ul>
				</div>
			</motion.div>
		</footer>
	);
}
